// 元素上滑滚出视窗
const upmovingoutContext = '@@upmovingoutContext'

export default {
  bind (el, binding, vnode) {
    const wHeight = window.innerHeight
    const documentHandler = function (e) {
      const elRect = el.getBoundingClientRect()
      const elTop = elRect.top
      const elHeight = elRect.height
      if (elTop < -elHeight || elTop > wHeight) {
        if (binding.expression) {
          vnode.context[el[upmovingoutContext].methodName](e)
        } else {
          el[upmovingoutContext].bindingFn(e)
        }
      }
    }

    el[upmovingoutContext] = {
      documentHandler,
      methodName: binding.expression,
      bindingFn: binding.value
    }
    document.addEventListener('scroll', el[upmovingoutContext].documentHandler)
  },
  unbind (el) {
    document.removeEventListener('scroll', el[upmovingoutContext].documentHandler)
  }
}



// WEBPACK FOOTER //
// ./src/directive/scrollOutView.js